import * as S from './style';

const ServiceTerms = () => (
	<S.Container>
		<S.Title>서비스 이용약관</S.Title>
		<S.PrimaryContentBox>
			<S.PrimaryContentTitle>제 1장 총칙</S.PrimaryContentTitle>
			<S.TertiaryContent>
				<S.TertiaryContentTitle>제 1조 (목적)</S.TertiaryContentTitle>
				<S.TertiaryContent>
					이 이용약관(이하 &apos;약관&apos;이라 합니다)은 대한화장품학회(이하 &apos;학회&apos;라 합니다)와 이용 고객(이하 &apos;회원&apos;이라 합니다)간에
					학회가 제공하는 모든 홈페이지(https://scsk.or.kr 이하 &apos;서비스&apos;라 합니다)의 이용조건 및 절차에 관한 사항을 규정함을 목적으로 합니다.
				</S.TertiaryContent>
			</S.TertiaryContent>
			<S.SecondaryContentBox>
				<S.TertiaryContent>
					<S.TertiaryContentTitle>제 2조 (용어의 정의)</S.TertiaryContentTitle>
					<S.TertiaryContent>이 약관에서 사용하는 용어의 정의는 다음과 같습니다.</S.TertiaryContent>
				</S.TertiaryContent>
				<S.SecondaryContent>
					<li>&apos;회원&#39; 이라 함은 이 약관에 동의하고 학회와 서비스 이용계약을 체결하고 이용자 아이디를 부여받은 자를 말합니다.</li>
					<li>&apos;이용계약&apos;이라 함은 이 약관을 포함하여 서비스 이용과 관련하여 학회와 회원 간에 체결하는 모든 계약을 말합니다.</li>
					<li>&apos;이용자 아이디(ID)&apos;라 함은 회원의 식별 및 서비스 이용을 위하여 회원이 설정하고 학회가 승인하는 문자와 숫자의 조합을 말합니다.</li>
					<li>&apos;비밀번호&apos;라 함은 이용자 아이디로 식별되는 회원의 본인 여부를 검증하기 위하여 회원이 설정한 문자와 숫자의 조합을 말합니다.</li>
					<li>&apos;관리자&apos;라 함은 서비스의 전반적인 관리와 원활한 운영을 위하여 학회에서 선정한 사람을 말합니다.</li>
					<li>&apos;해지&apos;라 함은 회원이 학회의 서비스 이용계약을 해약하는 것을 말합니다.</li>
				</S.SecondaryContent>
			</S.SecondaryContentBox>
			<S.SecondaryContentBox>
				<S.TertiaryContentTitle>제 3조 (이용약관의 효력 및 변경)</S.TertiaryContentTitle>
				<S.SecondaryContent>
					<li> 이 약관의 내용은 정당한 절차에 따라 서비스 화면에 게시하거나 기타의 방법으로 회원에게 공지함으로써 효력을 발생합니다.</li>
					<li>학회는 합당한 사유가 발생할 경우 이 약관을 변경할 수 있으며, 변경된 약관의 내용을 지체없이 회원에게 공지합니다.</li>
				</S.SecondaryContent>
			</S.SecondaryContentBox>
			<S.TertiaryContent>
				<S.TertiaryContentTitle>제 4조 (약관외 준칙)</S.TertiaryContentTitle>
				<S.TertiaryContent>이 약관에 명시되지 않은 사항은 관계법령 및 서비스별 약관의 취지에 따라 적용할 수 있습니다.</S.TertiaryContent>
			</S.TertiaryContent>
		</S.PrimaryContentBox>
		<S.PrimaryContentBox>
			<S.PrimaryContentTitle>제 2장 서비스 이용계약</S.PrimaryContentTitle>
			<S.SecondaryContentBox>
				<S.TertiaryContentTitle>제 5조 (이용 계약의 성립)</S.TertiaryContentTitle>
				<S.SecondaryContent>
					<li>이용계약은 회원의 이용계약 내용에 대한 동의와 이용신청에 대하여 학회가 승낙함으로써 성립합니다.</li>
					<li>이용계약에 대한 동의는 회원이 아래의 이용약관에 대한 &quot;동의합니다&quot; 버튼을 클릭하면 이 약관에 동의하는 것으로 간주합니다.</li>
				</S.SecondaryContent>
			</S.SecondaryContentBox>
			<S.SecondaryContentBox>
				<S.TertiaryContentTitle>제 6조 (이용 신청)</S.TertiaryContentTitle>
				<S.SecondaryContent>
					<li>이용 신청은 온라인으로 서비스에 접속하여 학회의 회원가입 신청 양식에 맞게 기재하여 신청합니다.</li>
					<li>
						모든 회원은 반드시 회원 본인의 정보를 제공하여야만 서비스를 이용할 수 있으며, 타인의 정보를 도용하거나 허위의 정보를 등록하는 등 본인의 정확한
						정보를 등록하지 않은 회원은 서비스 이용과 관련하여 아무런 권리를 주장할 수 없으며, 관계 법령에 따라 처벌 받을 수 있습니다.
					</li>
				</S.SecondaryContent>
			</S.SecondaryContentBox>
			<S.SecondaryContentBox>
				<S.TertiaryContentTitle>제 7조 (이용 신청의 승낙과 제한)</S.TertiaryContentTitle>
				<S.SecondaryContent>
					<li>학회는 제5조, 제6조의 규정에 따라 이용 신청을 하였을 때 서비스 이용을 승낙합니다.</li>
					<li>학회는 다음 각 호에 해당하는 경우에 대해서 승낙을 보류할 수 있습니다.</li>
					<ol type="a">
						<li>본인의 정확한 정보를 제공하지 아니한 경우</li>
						<li>법령 위반 또는 사회의 안녕과 질서, 미풍양속을 저해할 목적으로 신청한 경우</li>
						<li> 부정한 용도로 본 서비스를 이용하고자 하는 경우</li>
					</ol>
					<li>학회는 다음 각 호에 해당하는 경우에 승낙 제한사유가 해소될 때까지 승낙을 유보할 수 있습니다.</li>
					<ol type="a">
						<li>학회가 설비의 여유가 없는 경우</li>
						<li>학회의 기술상 지장이 있는 경우</li>
						<li>기타 학회의 사정상 이용승낙이 곤란한 경우</li>
					</ol>
					<li>학회는 회원가입 절차 완료 이후 제2항 각 호에 따른 사유가 발견된 경우 이용 승낙을 철회할 수 있습니다.</li>
				</S.SecondaryContent>
			</S.SecondaryContentBox>
			<S.TertiaryContent>
				<S.TertiaryContentTitle>제 8조 (계약사항의 변경)</S.TertiaryContentTitle>
				<S.TertiaryContent>
					회원은 이용신청시 기재한 사항이 변경되었을 경우에는 온라인으로 수정을 해야 하고 변경하지 않음으로 인하여 발생되는 문제의 책임은 회원에게 있습니다.
				</S.TertiaryContent>
			</S.TertiaryContent>
		</S.PrimaryContentBox>
		<S.PrimaryContentBox>
			<S.PrimaryContentTitle>제 3장 계약 당사자의 의무</S.PrimaryContentTitle>
			<S.SecondaryContentBox>
				<S.TertiaryContent>
					<S.TertiaryContentTitle>제 9조 (학회의 의무)</S.TertiaryContentTitle>
				</S.TertiaryContent>
				<S.SecondaryContent>
					<li>
						학회는 서비스 제공과 관련해서 알고 있는 회원의 신상정보를 본인의 승낙없이 제 3자에게 누설, 배포하지 않습니다.단, 전기통신기본법 등 법률의 규정에
						의해 국가기관의 요구가 있는 경우, 범죄에 대한 수사상의 목적이 있거나 정보통신윤리 위원회의 요청이 있는 경우 또는 기타 관계법령에서 정한 절차에 따른
						요청이 있는 경우에는 그러하지 않습니다.
					</li>
					<li>학회는 1항의 범위내에서 업무와 관련하여 회원전체 또는 일부의 개인정보에 관한 통계자료를 작성하여 이를 사용할 수 있습니다.</li>
					<li>
						학회는 계속적이고 안정적인 서비스의 제공을 위하여 설비에 장애가 생기거나 멸실된 때에는 부득이한 사유가 없는 한 지체 없이 이를 수리 또는 복구합니다.
					</li>
				</S.SecondaryContent>
			</S.SecondaryContentBox>
			<S.SecondaryContentBox>
				<S.TertiaryContentTitle>제 10조 (회원의 의무)</S.TertiaryContentTitle>
				<S.SecondaryContent>
					<li>
						회원은 회원가입 신청 또는 회원정보 변경 시 모든 사항을 사실에 근거하여 본인의 정확한 정보로 작성하여야 하며, 허위 또는 타인의 정보를 등록할 경우
						이와 관련된 모든 권리를 주장할 수 없습니다.
					</li>
					<li>회원은 서비스를 이용할 때 다음 각 호의 행위를 하지 않아야 합니다.</li>
					<ol type="a">
						<li>다른 회원의 ID를 부정하게 사용하는 행위</li>
						<li>서비스에서 얻은 정보를 학회의 사전승낙 없이 회원의 이용이외의 목적으로 복제하거나 이를 출판 및 방송 등에 사용하거나 제3자에게 제공하는 행위</li>
						<li>학회의 저작권, 제3자의 저작권 등 기타 권리를 침해하는 행위</li>
						<li>공공질서 및 미풍양속에 위반되는 내용의 정보, 문장, 도형 등을 타인에게 유포하는 행위</li>
						<li>죄와 결부된다고 객관적으로 판단되는 행위</li>
						<li>기타 관계법령에 위배되는 행위</li>
					</ol>
					<li>회원은 약관에서 규정하는 사항과 기타 학회가 정한 제반 규정, 공지사항등 학회가 공지하는 사항을 준수하여야 합니다.</li>
					<li>회원은 학회의 사전 승낙 없이 서비스를 이용하여 영업활동을 할 수 없으며, 그 영업활동의 결과에 대해 학회는 책임을 지지 않습니다.</li>
					<li>
						회원은 학회의 명시적 동의가 없는 한 서비스의 이용권한, 기타 이용계약상의 지위를 타인에게 양도, 증여할 수 없으며 이를 담보로 제공할 수 없습니다.
					</li>
				</S.SecondaryContent>
			</S.SecondaryContentBox>
			<S.TertiaryContent>
				<S.TertiaryContentTitle>제 11 조 (회원의 이용자 아이디(ID)와 비밀번호 관리에 대한 의무)</S.TertiaryContentTitle>
				<S.TertiaryContent>
					회원의 이용자ID 및 비밀번호의 관리책임은 회원에게 있습니다. 이를 소홀이 관리하여 발생하는 모든 결과에 대한 책임은 회원에게 있으며 학회는 그에 대한
					책임을 지지 않습니다.
				</S.TertiaryContent>
			</S.TertiaryContent>
		</S.PrimaryContentBox>
		<S.PrimaryContentBox>
			<S.PrimaryContentTitle>제 4장 서비스의 이용</S.PrimaryContentTitle>
			<S.SecondaryContentBox>
				<S.TertiaryContentTitle>제 12조 (서비스 이용 시간)</S.TertiaryContentTitle>
				<S.SecondaryContent>
					<li>
						서비스 이용은 학회의 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴, 1일 24시간 운영을 원칙으로 합니다. 단, 학회는 시스템 정기점검, 증설 및
						교체를 위해 학회가 정한 날이나 시간에 서비스를 일시 중단할 수 있으며, 예정되어 있는 작업으로 인한 서비스 일시 중단은 홈페이지를 통해 사전에
						공지합니다.
					</li>
					<li>
						학회는 긴급한 시스템 점검, 증설 및 교체, 설비의 장애, 정전 등 부득이한 사유가 발생한 경우 사전 예고 없이 일시적으로 서비스의 전부 또는 일부를 중단할
						수 있습니다.
					</li>
				</S.SecondaryContent>
			</S.SecondaryContentBox>
			<S.SecondaryContentBox>
				<S.TertiaryContentTitle>제 13조 (회원의 게시물 등)</S.TertiaryContentTitle>
				<S.SecondaryContent>
					<li>게시물이라 함은 회원이 서비스를 이용하면서 게시한 글, 사진, 각종 파일과 링크 등을 말합니다.</li>
					<li>
						학회는 다음 각 호에 해당하는 게시물 등을 회원의 사전 동의 없이 임시게시 중단, 수정, 삭제,이동 또는 등록 거부 등의 관련 조치를 취할수 있습니다.
					</li>
					<ol type="a">
						<li>다른 회원 또는 제 3자에게 심한 모욕을 주거나 명예를 손상시키는 내용인 경우</li>
						<li>공공질서 및 미풍양속에 위반되는 내용을 유포하거나 링크시키는 경우</li>
						<li>영리를 목적으로 하는 광고일 경우</li>
						<li>범죄와 결부된다고 객관적으로 인정되는 내용일 경우</li>
						<li>다른 이용자 또는 제 3자의 저작권 등 기타 권리를 침해하는 내용인 경우</li>
						<li>사적인 정치적 판단이나 종교적 견해의 내용으로 학회가 서비스 성격에 부합하지 않는다고 판단하는 경우</li>
						<li>학회에서 규정한 게시물 원칙에 어긋나거나, 게시판 성격에 부합하지 않는 경우</li>
						<li>기타 관계법령에 위배된다고 판단되는 경우</li>
					</ol>
				</S.SecondaryContent>
			</S.SecondaryContentBox>
			<S.SecondaryContentBox>
				<S.TertiaryContentTitle>제 14조 (게시물에 대한 저작권)</S.TertiaryContentTitle>
				<S.SecondaryContent>
					<li>학회가 작성한 게시물 또는 저작물에 대한 저작권 및 기타 지적재산권은 학회에 귀속합니다.</li>
					<li>
						회원이 서비스 내에 게시한 게시물의 저작권은 게시한 회원에게 귀속되며 학회는 게시자의 동의없이는 게시물을 사용할 수 없습니다. 단, 비영리적인 경우에는
						회원의 별도의 허락 없이 무상으로 저작권법에 규정하는 공정한 관행에 합치되게 합리적인 범위 내에서 회원이 등록한 게시물을 사용할 수 있습니다.
					</li>
					<li>회원은 서비스를 이용하여 얻은 정보를 가공, 판매하는 행위 등 상업적으로 사용할 수 없습니다.</li>
				</S.SecondaryContent>
			</S.SecondaryContentBox>
			<S.TertiaryContent>
				<S.TertiaryContentTitle>제 15조 (정보의 제공)</S.TertiaryContentTitle>
				<S.TertiaryContent>
					학회는 회원에게 서비스 이용에 필요가 있다고 인정되는 각종 정보에 대해서 전자우편이나 서신, SMS, 전화 등의 방법으로 회원에게 제공할 수 있으며, 회원은
					원치않을 경우 서비스 이용신청시 또는 회원정보수정 메뉴에서 정보 수신거부 신청을 할 수 있습니다.
				</S.TertiaryContent>
			</S.TertiaryContent>
		</S.PrimaryContentBox>
		<S.PrimaryContentBox>
			<S.PrimaryContentTitle>제 5장 계약 해지 및 이용 제한</S.PrimaryContentTitle>
			<S.SecondaryContentBox>
				<S.TertiaryContentTitle>제 16조 (계약해지 및 이용제한)</S.TertiaryContentTitle>
				<S.SecondaryContent>
					<li>회원이 이용계약을 해지하고자 하는 때에는 회원 본인이 온라인(전자우편)을 통해 학회에 해지를 신청해야 합니다.</li>
					<li>
						학회는 회원이 다음 각 호에 해당하는 행위를 하였을 경우 사전통지 없이 이용계약을 해지하거나 또는 기간을 정하여 서비스 이용을 중지할 수 있습니다.
					</li>
					<ol type="a">
						<li>타인의 서비스 ID 및 비밀번호를 도용한 경우</li>
						<li>서비스 운영을 고의로 방해한 경우</li>
						<li>가입한 이름이 실명이 아닌 경우</li>
						<li>같은 사용자가 다른 ID로 이중등록을 한 경우</li>
						<li>공공질서 및 미풍양속에 저해되는 내용을 고의로 유포시킨 경우</li>
						<li>회원이 국익 또는 사회적 공익을 저해할 목적으로 서비스이용을 계획 또는 실행하는 경우</li>
						<li>타인의 명예를 손상시키거나 불이익을 주는 행위를 한 경우</li>
						<li>서비스의 안정적 운영을 방해할 목적으로 다량의 정보를 전송하거나 광고성 정보를 전송하는 경우</li>
						<li>학회, 다른 회원 또는 제3자의 지적재산권을 침해하는 경우</li>
						<li>정보통신윤리위원회 등 외부기관의 시정요구가 있거나 불법선거운동과 관련하여 선거관리위원회의 유권해석을 받은 경우</li>
						<li>학회의 서비스 정보를 이용하여 얻은 정보를 학회의 사전 승낙없이 복제 또는 유통시키거나 상업적으로 이용하는 경우</li>
						<li>장기간 휴면 가입자에 대하여 통지할 경우 그 통지 기간 내에도 서비스이용에 대한 의사표현을 하지 않은 경우</li>
						<li>기타 학회가 정한 이용조건에 위반한 경우</li>
					</ol>
				</S.SecondaryContent>
			</S.SecondaryContentBox>
		</S.PrimaryContentBox>
		<S.PrimaryContentBox>
			<S.PrimaryContentTitle>제 6장 손해배상 및 기타사항</S.PrimaryContentTitle>
			<S.TertiaryContent>
				<S.TertiaryContentTitle>제 17조 (손해배상)</S.TertiaryContentTitle>
				<S.TertiaryContent>
					학회는 무료로 제공하는 서비스의 이용과 관련하여 학회의 고의, 과실에 의한 것이 아닌 한 회원에게 발생한 어떠한 손해도 책임을 지지 않습니다.
				</S.TertiaryContent>
			</S.TertiaryContent>
			<S.SecondaryContentBox>
				<S.TertiaryContentTitle>제 18 조 (면책조항)</S.TertiaryContentTitle>
				<S.SecondaryContent>
					<li>학회는 천재지변, 전쟁 및 기타 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 대한 책임이 면제됩니다.</li>
					<li>학회는 서비스용 설비의 보수, 교체, 정기점검, 공사 등 부득이한 사유로 발생한 손해에 대한 책임이 면제됩니다.</li>
					<li>학회는 회원의 귀책사유로 인한 서비스 이용의 장애에 대한 책임이 면제됩니다.</li>
					<li>
						학회는 회원이 서비스를 이용하여 기대하는 수익을 얻지 못하거나 상실한 것에 대하여 책임을 지지 않으며, 서비스를 이용하면서 얻은 자료로 인한 손해에
						대하여 책임을 지지 않습니다.
					</li>
					<li>
						학회는 회원이 서비스에 게재한 각종 정보, 자료, 사실의 신뢰도, 정확성 등 내용에 대하여 책임을 지지 않으며, 그밖에 서비스를 통하여 얻은 자료로 인한
						손해에 관한 책임이 면제됩니다.
					</li>
				</S.SecondaryContent>
			</S.SecondaryContentBox>
			<S.TertiaryContent>
				<S.TertiaryContentTitle>제 19 조 (통지)</S.TertiaryContentTitle>
				<S.TertiaryContent>
					학회가 회원에 대하여 통지를 하는 경우 회원이 학회에 등록한 전자우편 주소를 이용하거나, 공지 게시판을 통해 5일 이상 게시함으로써 개별 통지에 갈음할 수
					있습니다.
				</S.TertiaryContent>
			</S.TertiaryContent>
			<S.SecondaryContentBox>
				<S.TertiaryContentTitle>제 20 조 (재판권 및 준거법)</S.TertiaryContentTitle>
				<S.SecondaryContent>
					<li>이 약관에 명시되지 않은 사항은 전기통신사업법 등 대한민국의 관계법령과 상관습에 따릅니다.</li>
					<li>서비스 이용으로 발생한 분쟁에 대해 소송이 제기되는 경우 학회의 사무국 소재지를 관할하는 법원으로 합니다.</li>
				</S.SecondaryContent>
			</S.SecondaryContentBox>
			<S.TertiaryContent>
				<S.TertiaryContentTitle>부칙</S.TertiaryContentTitle>
				<S.TertiaryContent style={{ color: '#DC2626' }}>본 약관은 2021년 3월 1일부터 적용됩니다.</S.TertiaryContent>
			</S.TertiaryContent>
			<S.SecondaryContentBox />
		</S.PrimaryContentBox>
	</S.Container>
);

export default ServiceTerms;
